const CART_EVENTS_TYPES = {
  1: 'mWeb_Cart_Customize_Button_Clicked',
  2: 'mWeb_Cart_Customization_UpdateCart_Clicked',
  3: 'mWeb_Cart_Customization_Cancel_Clicked',
};

export const cartTrack = (data) => {
  try {
    window.__bgtracker.track('VIEW_CART', { hitName: 'VIEW_CART', ...data });
  } catch (error) {
    console.log(error);
  }
};

export const cartLoginTrack = (User_ID) => {
  window.__bgtracker.track('LOGIN_TO_PLACE_ORDER_CLICKED', {
    hitName: 'LOGIN_TO_PLACE_ORDER_CLICKED',
    Login_Method: 'Phone OTP',
    User_ID,
  });
};

export const placeOrderTrack = (Cart_Details) => {
  try {
    window.__bgtracker.track('PLACE_ORDER_CLICKED', { hitName: 'PLACE_ORDER_CLICKED', Cart_Details });
  } catch (error) {}
};

export const cartEventsTrack = (hitNameType, data) => {
  const hitName = CART_EVENTS_TYPES[hitNameType];
  if (!data) return;
  try {
    window.__bgtracker.track(hitName, {
      hitName,
      ...data,
    });
  } catch (error) {
    console.log(error);
  }
};
